import {Action} from 'redux';
import {isType} from 'typescript-fsa';
import * as actions from './actions';
import {ObservationV2, StationObservations, WeatherState} from './types';

const initialState: WeatherState = {
  pending: false,
  success: false,
};

export const weatherReducer = (state = initialState, action: Action): WeatherState => {
  if (isType(action, actions.getWeatherDatas.started)) {
    return {
      ...state,
      pending: true,
    };
  }

  if (isType(action, actions.getWeatherDatas.done)) {
    let items = action.payload.result as ObservationV2[];
    let stationObservationCopy = [] as StationObservations[];
    let stationIndex: number;

    if (state.stationObservations) {
      stationObservationCopy = [...state.stationObservations];
    }

    if (items.length > 0) {
      if (stationObservationCopy.length > 0) {
        stationIndex = stationObservationCopy.findIndex((so) => so.stationId === items[0].properties.stationId);
      } else {
        stationIndex = -1;
      }
      if (stationIndex !== -1) {
        stationObservationCopy[stationIndex].observations = items;
      } else {
        let a: StationObservations = {observations: items, stationId: items[0].properties.stationId!};
        stationObservationCopy.push(a);
      }
    }

    return {
      ...state,
      stationObservations: stationObservationCopy,
      pending: false,
    };
  }

  if (isType(action, actions.getWeatherDatas.failed)) {
    return {
      ...state,
      pending: false,
    };
  }

  if (isType(action, actions.getBackendDmiDataAction.started)) {
    return {
      ...state,
      pending: true,
    };
  }

  if (isType(action, actions.getBackendDmiDataAction.done)) {
    return {
      ...state,
      pending: false,
    };
  }

  if (isType(action, actions.getBackendDmiDataAction.failed)) {
    return {
      ...state,
      pending: false,
    };
  }

  return state;
};
